import type { OrderInvoiceFile, OrderInvoicePayload } from '../../model/invoice/interfaces'
import type { ApiResponse } from '@shared/api'

import { useAdminRoutes } from '@shared/lib/routes'
import { getAxiosErrorMessage } from '@shared/api'
import { useToast } from '@shared/ui/toast'

import { useOrderInvoiceStore } from '../../model/invoice/store'

const DEFAULT_SUCCESS_MESSAGE = 'Invoice saved'

/** `POST /admin-api/orders/{order}/invoices` — saves the PDF and the field values; answers with the new file. */
export const useOrderInvoiceSave = async (
  orderId: string | number,
  payload: OrderInvoicePayload,
): Promise<OrderInvoiceFile | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const store = useOrderInvoiceStore()
  const url = useAdminRoutes('admin.order.invoices', { order_id: orderId })

  store.setPreviewLoading(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.post<ApiResponse>(url, payload)

    if (!data.success || !data.data) {
      toast.error(data.message || 'Unexpected error.')
      return null
    }

    const invoice: OrderInvoiceFile = data.data

    toast.success(data.message || DEFAULT_SUCCESS_MESSAGE)

    return invoice
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return null
  } finally {
    store.setPreviewLoading(false)
  }
}
